export default () => () => {
  // Cleanup if needed
}
